import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, Popover } from '@material-ui/core';
import ViewHeadlineIcon from '@material-ui/icons/ViewHeadline';
import CreateIcon from '@material-ui/icons/Create';
import UpdateIcon from '@material-ui/icons/Update';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import AssessmentIcon from '@material-ui/icons/Assessment';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloudDoneIcon from '@material-ui/icons/CloudDone';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import "../Preventive Maintenance/PreventiveMaintenance.css";
import { useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import { useDispatch } from 'react-redux';
import { getAllPV_plans } from '../../ReduxStore/CreatePlanSlice';

const PhysicalVerification = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
    ];
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [allEvents, setAllEvents] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedEvent, setSelectedEvent] = useState(null)
    const Role = localStorage.getItem("userRole");

    const handleEventClick = (info) => {
        // Prevent the default click behavior
        info.jsEvent.preventDefault();

        // Set the selected event and open the popover
        setSelectedEvent(info.event);
        setAnchorEl(info.jsEvent.currentTarget);
    };

    const handleClosePopover = () => {
        setAnchorEl(null);
        setSelectedEvent(null);
    };

    const handler = (route) => {
        navigate(route)
    }


    const getAllplans = async () => {
        try {
            const action = dispatch(getAllPV_plans());
            const res = await action.unwrap();
            if (res.result) {
                const events = res.result.pv_plan.map(plan => ({
                    title: plan.vendor_details.vendor_group || "No Title",
                    start: plan.start_date,
                    extendedProps: {
                        vendor_no: plan.vendor_details.vendor,
                        details: plan.details,
                    },
                }));
                setAllEvents(events);
            }
        } catch (error) {
            console.error("error", error);
            // toast.error(error.message || "Something went wrong!");
        }

    }

    useEffect(() => {
        const fetchData = async () => {
            await getAllplans();
            setLoading(false);
        };
        fetchData();
    }, [])



    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        Physical Verification
                    </Typography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Physical Verification" />
                </Box>
                <Box mb={2}>
                    <Typography variant="body1" style={{ fontSize: 'clamp(1rem, 1.5vw, 1.5rem)', fontWeight: 400 }}>
                        Select an option
                    </Typography>
                </Box>
                <Grid container spacing={3}>
                    {/* Left Side: Options */}
                    <Grid item xs={12} md={6}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={10} className='PM' onClick={() => { handler("/physical-verification/plan-overview") }}>
                                <div className='options'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <ViewComfyIcon />
                                        <p className='text'>
                                            Plan Overview
                                        </p>
                                    </div>
                                    <DoubleArrowIcon />
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item className='PM' xs={12} sm={10} onClick={() => handler("/physical-verification/log-overview")}>
                                <div className='options'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <ViewHeadlineIcon className='MuiIcon-fontSizeLarge' />
                                        <p className='text'>
                                            Log Overview
                                        </p>
                                    </div>
                                    <DoubleArrowIcon />
                                </div>
                            </Grid>
                        </Grid>
                        {(Role === 'admin' || Role === 'supplier') && <Grid container spacing={3}>
                            <Grid item className='PM' xs={12} sm={10} onClick={() => { handler("/physical-verification/create-plan") }}>
                                <div className='options'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <CreateIcon className='MuiIcon-fontSizeLarge' />
                                        <p className='text'>
                                            Create Plan
                                        </p>
                                    </div>
                                    <DoubleArrowIcon />
                                </div>
                            </Grid>
                        </Grid>}
                        <Grid container spacing={3}>
                            <Grid item className='PM' xs={12} sm={10} onClick={() => { handler("/physical-verification/reschedule-plan") }}>
                                <div className='options'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <UpdateIcon />
                                        <p className='text'>
                                            Reschedule Plan
                                        </p>
                                    </div>
                                    <DoubleArrowIcon />
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item className='PM' xs={12} sm={10} onClick={() => handler("/physical-verification/ng-checkpoints")}>
                                <div className='options'>
                                    <div style={{ display: 'flex', alignItems: 'center' }} >
                                        <CloudDoneIcon />
                                        <p className='text'>
                                            NG CheckPoints
                                        </p>
                                    </div>
                                    <DoubleArrowIcon />
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item className='PM' xs={12} sm={10} onClick={() => handler("/physical-verification/ng-approve-checkpoints")}>
                                <div className='options'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <CheckCircleIcon />
                                        <p className='text'>
                                            Approve NG CheckPoints
                                        </p>
                                    </div>
                                    <DoubleArrowIcon />
                                </div>
                            </Grid>
                        </Grid>
                        {/* <Grid container spacing={3}>
                            <Grid item className='PM' xs={12} sm={10}>
                                <div className='options'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <CheckCircleIcon />
                                        <p className='text'>
                                            Approve Checksheet
                                        </p>
                                    </div>
                                    <DoubleArrowIcon />
                                </div>
                            </Grid>
                        </Grid> */}
                        <Grid container spacing={3} style={{ marginBottom: '10px' }}>
                            <Grid item className='PM' xs={12} sm={10} onClick={() => { handler("/physical-verification/reports") }}>
                                <div className='options'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <AssessmentIcon />
                                        <p className='text'>
                                            Reports
                                        </p>
                                    </div>
                                    <DoubleArrowIcon />
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box>
                            <Box
                                className="calendar-container"
                                boxShadow={3}
                                borderRadius={8}
                                overflow="hidden"
                            >
                                <FullCalendar
                                    plugins={[
                                        dayGridPlugin,
                                        timeGridPlugin,
                                        interactionPlugin,
                                    ]}
                                    initialView="dayGridMonth"
                                    headerToolbar={{
                                        left: 'prev,next today',
                                        center: 'title',
                                        right:
                                            'dayGridMonth,timeGridWeek,timeGridDay',
                                    }}
                                    buttonText={{
                                        today: 'Today',
                                        month: 'Month',
                                        week: 'Week',
                                        day: 'Day',
                                    }}
                                    events={allEvents}
                                    eventClick={handleEventClick}
                                    // eventDisplay="list-item"
                                    selectable={true}
                                    editable={true}
                                    height="auto"
                                />.
                                {/* Event Popover */}
                                <Popover
                                    open={Boolean(anchorEl)}
                                    anchorEl={anchorEl}
                                    onClose={handleClosePopover}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                >
                                    <Box p={2}>
                                        {selectedEvent && (
                                            <>
                                                <Typography variant="h6">
                                                    {selectedEvent.title}
                                                </Typography>
                                                <Typography variant="body2">
                                                    Start: {selectedEvent.start.toLocaleString()}
                                                </Typography>
                                                <Typography variant="body2">
                                                    Vendor Code: {selectedEvent.extendedProps.vendor_no || "No Vendor available"}
                                                </Typography>
                                            </>
                                        )}
                                    </Box>
                                </Popover>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Layout >
    );
};

export default PhysicalVerification;
